import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import BookingSearchSummary from './BookingSearchSummary';

export default injectIntl(withRouter(BookingSearchSummary));
